var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNpv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.4932C0 24.0495 6.93687 30.9864 15.4932 30.9864V17.1241C15.4932 16.6915 15.6262 16.3155 15.9709 15.9709C16.3155 15.6262 16.6915 15.4932 17.1241 15.4932H30.9864C30.9864 6.93687 24.0495 0 15.4932 0C6.93687 0 0 6.93687 0 15.4932Z",
    fill: "#595D6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3858 22.3857C20.3858 21.2812 21.2812 20.3857 22.3858 20.3857H30.171V30.1709H20.3858V22.3857Z",
    fill: "#595D6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpv);
export default __webpack_public_path__ + "static/media/npv.503684905081f394ddfa6c5f13bed831.svg";
export { ForwardRef as ReactComponent };